import PropTypes from "prop-types";
import "./Skeleton.css";

/**
 * Skeleton placeholder component with shimmer animation
 * Used for loading states when content is being fetched
 */
const Skeleton = ({ 
  width = "100%", 
  height = "24px", 
  borderRadius = "4px",
  className = "",
  variant = "text", // "text", "circular", "rectangular"
}) => {
  const variantStyles = {
    text: { borderRadius: "4px" },
    circular: { borderRadius: "50%" },
    rectangular: { borderRadius: borderRadius },
  };

  const style = {
    width,
    height,
    ...variantStyles[variant],
    ...(variant === "rectangular" && { borderRadius }),
  };

  return (
    <div 
      className={`skeleton-shimmer ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
};

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["text", "circular", "rectangular"]),
};

export default Skeleton;
